var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28 9.31297C1.20533 9.31297 1.13067 9.1823 1.056 8.92097C1.01867 8.6223 1 8.30497 1 7.96897C1 7.6703 1.01867 7.40897 1.056 7.18497C1.09333 6.92364 1.14933 6.79297 1.224 6.79297H23.68C23.7547 6.79297 23.8107 6.92364 23.848 7.18497C23.9227 7.4463 23.96 7.7263 23.96 8.02497C23.96 8.36097 23.9227 8.65963 23.848 8.92097C23.8107 9.1823 23.7547 9.31297 23.68 9.31297H1.28ZM1.28 17.153C1.20533 17.153 1.13067 17.0223 1.056 16.761C1.01867 16.4623 1 16.145 1 15.809C1 15.5103 1.01867 15.249 1.056 15.025C1.09333 14.7636 1.14933 14.633 1.224 14.633H23.68C23.7547 14.633 23.8107 14.7636 23.848 15.025C23.9227 15.2863 23.96 15.5663 23.96 15.865C23.96 16.201 23.9227 16.4996 23.848 16.761C23.8107 17.0223 23.7547 17.153 23.68 17.153H1.28Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqual);
export default __webpack_public_path__ + "static/media/equal.6dcd9c224243d77ccd3368e41b466c30.svg";
export { ForwardRef as ReactComponent };